export enum ShipmentReportName {
  Waybill = 'waybill',
  Load = 'load',
  To = 'to',
}
